module.exports = __webpack_public_path__ + "img/2_207.aa91598c.png";